import * as React from 'react'
import type { SVGProps } from 'react'
function SvgMsKlimadashboardIconsButtonInvertiertGebaeud(props: SVGProps<SVGSVGElement>) {
  return <svg
    data-name="Ebene 1"
    id="MS_Klimadashboard_Icons_Button_invertiert_Gebaeud_svg__Ebene_1"
    viewBox="0 0 46.34 43"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <style>
        {
          '.MS_Klimadashboard_Icons_Button_invertiert_Gebaeud_svg__cls-1{fill:#fff}'
        }
      </style>
    </defs>
    <path
      className="MS_Klimadashboard_Icons_Button_invertiert_Gebaeud_svg__cls-1"
      d="M36.87 36.22c-.69 0-1.25-.56-1.25-1.25V19.1h-3.37c-.27 0-.54-.09-.76-.26l-8.18-6.22-7.94 5.94c-.21.16-.47.25-.74.25l-13.37.11c-.55 0-1.04-.36-1.2-.89-.16-.53.05-1.1.51-1.41l7.32-4.79V5.52c0-.69.56-1.25 1.25-1.25h4.33c.69 0 1.25.56 1.25 1.25v1.66l7.7-6.12a1.26 1.26 0 0 1 1.51-.04l21.89 15.69c.44.31.63.88.46 1.39s-.64.87-1.18.88l-6.99.1v15.88c0 .69-.56 1.25-1.25 1.25Zm-4.2-19.62h4.2l4.41-.06L23.24 3.61l-8.99 7.14c-.38.3-.89.35-1.32.15-.43-.21-.71-.65-.71-1.13v-3h-1.83v5.74c0 .42-.21.81-.57 1.05l-4.33 2.83 8.71-.07 8.37-6.26c.45-.33 1.06-.33 1.51 0l8.59 6.54Z"
    />
    <path
      className="MS_Klimadashboard_Icons_Button_invertiert_Gebaeud_svg__cls-1"
      d="M38.4 42.2H8.7c-.69 0-1.25-.56-1.25-1.25V22.33a1.25 1.25 0 0 1 2.5 0V39.7h28.46a1.25 1.25 0 0 1 0 2.5Z"
    />
    <path
      className="MS_Klimadashboard_Icons_Button_invertiert_Gebaeud_svg__cls-1"
      d="M22.32 35.89h-7.49c-.69 0-1.25-.56-1.25-1.25V22.56c0-.69.56-1.25 1.25-1.25h7.42c.69 0 1.25.56 1.25 1.25v5.76a1.25 1.25 0 0 1-2.5 0v-4.51h-4.92v9.58h6.24a1.25 1.25 0 0 1 0 2.5Z"
    />
  </svg>
}
export default SvgMsKlimadashboardIconsButtonInvertiertGebaeud
